export default {
  "--border-neutral": "_--border-neutral_e9alq_1",
  "--border-neutral-faded": "_--border-neutral-faded_e9alq_1",
  "--border-positive": "_--border-positive_e9alq_1",
  "--border-positive-faded": "_--border-positive-faded_e9alq_1",
  "--border-warning": "_--border-warning_e9alq_1",
  "--border-warning-faded": "_--border-warning-faded_e9alq_1",
  "--border-critical": "_--border-critical_e9alq_1",
  "--border-critical-faded": "_--border-critical-faded_e9alq_1",
  "--border-primary": "_--border-primary_e9alq_1",
  "--border-primary-faded": "_--border-primary-faded_e9alq_1",
  "--border-disabled": "_--border-disabled_e9alq_1",
  "--border-brand": "_--border-brand_e9alq_1",
  "--border-transparent": "_--border-transparent_e9alq_1",
  "--border-neutral--m": "_--border-neutral--m_e9alq_1",
  "--border-neutral-faded--m": "_--border-neutral-faded--m_e9alq_1",
  "--border-positive--m": "_--border-positive--m_e9alq_1",
  "--border-positive-faded--m": "_--border-positive-faded--m_e9alq_1",
  "--border-warning--m": "_--border-warning--m_e9alq_1",
  "--border-warning-faded--m": "_--border-warning-faded--m_e9alq_1",
  "--border-critical--m": "_--border-critical--m_e9alq_1",
  "--border-critical-faded--m": "_--border-critical-faded--m_e9alq_1",
  "--border-primary--m": "_--border-primary--m_e9alq_1",
  "--border-primary-faded--m": "_--border-primary-faded--m_e9alq_1",
  "--border-disabled--m": "_--border-disabled--m_e9alq_1",
  "--border-brand--m": "_--border-brand--m_e9alq_1",
  "--border-transparent--m": "_--border-transparent--m_e9alq_1",
  "--border-neutral--l": "_--border-neutral--l_e9alq_1",
  "--border-neutral-faded--l": "_--border-neutral-faded--l_e9alq_1",
  "--border-positive--l": "_--border-positive--l_e9alq_1",
  "--border-positive-faded--l": "_--border-positive-faded--l_e9alq_1",
  "--border-warning--l": "_--border-warning--l_e9alq_1",
  "--border-warning-faded--l": "_--border-warning-faded--l_e9alq_1",
  "--border-critical--l": "_--border-critical--l_e9alq_1",
  "--border-critical-faded--l": "_--border-critical-faded--l_e9alq_1",
  "--border-primary--l": "_--border-primary--l_e9alq_1",
  "--border-primary-faded--l": "_--border-primary-faded--l_e9alq_1",
  "--border-disabled--l": "_--border-disabled--l_e9alq_1",
  "--border-brand--l": "_--border-brand--l_e9alq_1",
  "--border-transparent--l": "_--border-transparent--l_e9alq_1",
  "--border-neutral--xl": "_--border-neutral--xl_e9alq_1",
  "--border-neutral-faded--xl": "_--border-neutral-faded--xl_e9alq_1",
  "--border-positive--xl": "_--border-positive--xl_e9alq_1",
  "--border-positive-faded--xl": "_--border-positive-faded--xl_e9alq_1",
  "--border-warning--xl": "_--border-warning--xl_e9alq_1",
  "--border-warning-faded--xl": "_--border-warning-faded--xl_e9alq_1",
  "--border-critical--xl": "_--border-critical--xl_e9alq_1",
  "--border-critical-faded--xl": "_--border-critical-faded--xl_e9alq_1",
  "--border-primary--xl": "_--border-primary--xl_e9alq_1",
  "--border-primary-faded--xl": "_--border-primary-faded--xl_e9alq_1",
  "--border-disabled--xl": "_--border-disabled--xl_e9alq_1",
  "--border-brand--xl": "_--border-brand--xl_e9alq_1",
  "--border-transparent--xl": "_--border-transparent--xl_e9alq_1"
};import "ni:sha-256;YZG_RaITjrszQNNimM_AZN5hPaCraRpb9YctyRNwvUo";